import { render, staticRenderFns } from "./DoctorInputGroup.vue?vue&type=template&id=4e900361&scoped=true&"
import script from "./DoctorInputGroup.vue?vue&type=script&lang=ts&"
export * from "./DoctorInputGroup.vue?vue&type=script&lang=ts&"
import style0 from "./DoctorInputGroup.vue?vue&type=style&index=0&id=4e900361&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e900361",
  null
  
)

export default component.exports